import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
  Spinner,
} from '@razorpay/blade/components';
import React from 'react';
import { OverrideEmployeeListingProps } from './types';
import { EmployeesTable } from 'components/SalaryStructures/creation/components/EmployeeTable';

const OverrideEmployeeListing = ({
  isOpen,
  onDismiss,
  employees,
  isLoading,
  isFetching,
}: OverrideEmployeeListingProps) => {
  

  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} size="medium">
      <ModalHeader title="View Employee details" />
      <ModalBody>
        <Box>
          <Text weight="semibold" marginBottom="spacing.5">
            Total Employees: {employees.length}
          </Text>
          <EmployeesTable
            isLoading={isLoading}
            isFetching={isFetching}
            employees={employees}
            hasPagination={false}
          />
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box display="flex" gap="spacing.3" justifyContent="flex-end" width="100%">
          <Button variant="secondary" onClick={() => onDismiss?.()}>
            Close
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};

export { OverrideEmployeeListing };
